import { render } from "./QuickPad.vue?vue&type=template&id=c028cfca&scoped=true"
import script from "./QuickPad.vue?vue&type=script&lang=js"
export * from "./QuickPad.vue?vue&type=script&lang=js"

import "./QuickPad.vue?vue&type=style&index=0&id=c028cfca&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c028cfca"]])

export default __exports__